import React from "react";
import { Card, CardBody, CardHeader, Divider, Chip } from "@nextui-org/react";
import { capitalize } from "../../controllers/APIController";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuilding, faArrowRight, faGlobe } from "@fortawesome/free-solid-svg-icons";

const OrgCard = ({ title }) => {
  const navigate = useNavigate();
  return (
    <div
      className="cursor-pointer group"
      onClick={() => navigate(`/${title}/dashboard`)}
    >
      <Card className="w-full h-auto min-h-[180px] border border-neutral-200 hover:border-primary-300 transition-all duration-200 bg-white shadow-sm hover:shadow-lg group-hover:scale-[1.02]" shadow="none">
        <CardHeader className="flex gap-4 pb-3">
          <div className="flex items-center justify-center w-12 h-12 bg-primary-100 rounded-lg group-hover:bg-primary-200 transition-colors">
            <FontAwesomeIcon icon={faBuilding} className="text-primary-600 text-lg" />
          </div>
          <div className="flex flex-col flex-1">
            <div className="flex items-center gap-2 mb-1">
              <p className="text-lg font-semibold text-neutral-900">{capitalize(title) || "Audyt- Org"}</p>
              <Chip size="sm" variant="flat" color="success" className="text-xs">
                Active
              </Chip>
            </div>
            <div className="flex items-center gap-2 text-neutral-500">
              <FontAwesomeIcon icon={faGlobe} className="text-xs" />
              <p className="text-sm">
                {process.env.REACT_APP_IP_ADDRESS}/{title}
              </p>
            </div>
          </div>
        </CardHeader>
        <Divider />
        <CardBody className="pt-4">
          <div className="flex items-center justify-between">
            <p className="text-sm text-neutral-600">
              Visit ESG analysis of {capitalize(title)}
            </p>
            <div className="p-2 bg-primary-100 rounded-full group-hover:bg-primary-200 transition-colors">
              <FontAwesomeIcon icon={faArrowRight} className="text-primary-600 text-xs" />
            </div>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default OrgCard;
